import { useQuery } from '@tanstack/react-query';
import { API_URL } from '../config';
import { toApiError } from '../lib/api-error';

export type SandboxArtifact = {
  id: string;
  taskId: string;
  artifactType: string;
  filename: string;
  content: string;
  metadata?: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
};

export async function fetchArtifacts(templateId: string): Promise<SandboxArtifact[]> {
  const res = await fetch(`${API_URL}/org/environments/templates/${templateId}/artifacts`, {
    credentials: 'include',
  });

  if (!res.ok) {
    throw await toApiError(res, 'Failed to fetch sandbox artifacts');
  }

  const json = (await res.json()) as { ok: boolean; data: SandboxArtifact[] };
  if (!json.ok) {
    throw new Error('Failed to fetch sandbox artifacts');
  }

  return json.data;
}

export function useSandboxArtifacts(templateId: string | null) {
  return useQuery({
    queryKey: ['sandbox-artifacts', templateId],
    queryFn: () => fetchArtifacts(templateId!),
    enabled: !!templateId,
  });
}
